import React, { useEffect,  useState } from "react";
import Header from "../../layouts/Header.jsx";
import Sidebar from "../../layouts/Sidebar.jsx";
import { Table } from "antd";
// import {
//     itemRender,
//     onShowSizeChange,
// } from "../../_components/paginationfunction.jsx";
// import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import alertify from "alertifyjs";
import "../../../node_modules/alertifyjs/build/css/alertify.css";
import "../../../node_modules/alertifyjs/build/css/themes/semantic.css";
import MessageView from "./MessageView.jsx";
import ApiService from "../../service/httpService.js";


const Message = () => {
    //state management
    alertify.set("notifier", "position", "top-right");
    const [isLoding, setisLoding] = useState(false)
    const [datasource, setDataSource] = useState([]);
    const [menu, setMenu] = useState(false);
    const [EditData, setEditData] = useState({})
    const [formData, setFormData] = useState({ fromDate: "", ToDate: "" })
    const [validation, setValidation] = useState({ fromDate: true, ToDate: true })
    const [isExport, setisExport] = useState(false)
   

    function formatDate(dateStr) {
        const date = new Date(dateStr);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12; // Convert to 12-hour format

        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    }

    //fetching employee datas
    const fetchmessage = async () => {
        setisLoding(true)
        try {
            const res = await ApiService.getPublic(`mp_write_to_md_report.php?from_date=${formData.fromDate}&to_date=${formData.ToDate}&authToken=`);
            console.log("message", res);
            setDataSource(res);
            setisLoding(false)
            if (res === null || res.length === 0) {
        alertify.error("No Data Found");
      }

        } catch (err) {
            console.log("error on fetchmessage", err);
            setisLoding(false)
        }
    };

    //export button
    useEffect(() => {
        if (datasource.length !== 0) {
            setisExport(true)
        }
        else {
            setisExport(false)
        }
    }, [datasource])


    useEffect(() => {
        for (const key in formData) {
            const value = formData[key];
            if (
                value !== undefined &&
                value !== null &&
                value.toString().trim() !== ""
            ) {
                setValidation((prev) => ({ ...prev, [key]: true }));
            }
        }
    }, [formData]);

    const HandleGenerate = () => {
        let Isvalid = true;
        for (const key in formData) {
            const value = formData[key];
            if (
                value === undefined ||
                value === null ||
                value.toString().trim() === ""
            ) {
                Isvalid = false;
                setValidation((prev) => ({ ...prev, [key]: false }));
            }
        }

        if (Isvalid) {
            fetchmessage()
        }
        else {
            alertify.error("Please select both From and To dates!");
        }
    }

    const handleEditClick = (record) => {
        setEditData(record)
        console.log("record ", record)
    }

        function reorderAndFilterKeys(data, keyOrder) {
  return data.map(obj => {
    const newObj = {};
    keyOrder.forEach(key => {
      if (key in obj) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  });
}


    const HandleExport = (data) => {

        // Step 1: Convert JSON data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(reorderAndFilterKeys(data,['employee',"mobile","date_time","incharge","status","message"]));

        // Step 2: Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const now = new Date();
          const pad = (n) => n.toString().padStart(2, "0");
          
          const formattedDate = `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`;
          const formattedTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
          
          
              // Step 3: Write the workbook and trigger download
              XLSX.writeFile(workbook, `Message_report_${formattedDate}_${formattedTime}.xlsx`);

    }

    const toggleMobileMenu = () => {
        setMenu(!menu);
    };


    const columns = [
        {
            title: "Name",
            dataIndex: "employee",
            sorter: (a, b) => a.employee.localeCompare(b.employee),
        },
        {
            title: "Date Time",
            dataIndex: "date_time",
            sorter: (a, b) => new Date(a.date_time) - new Date(b.date_time),
            render: (text) => formatDate(text)
        },
        {
            title: "Incharge",
            dataIndex: "incharge",
            sorter: (a, b) => a.incharge.localeCompare(b.incharge),
        },
        {
            title: "Message",
            dataIndex: "message",
            sorter: (a, b) => a.message.localeCompare(b.message),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (status) => (
                <div>
                    {status == "approved" && (
                        <span className="badge bg-success-light">
                            <i className="fe fe-check me-1"></i>Read
                        </span>
                    )}
                    {status == "Denied" && (
                        <span className="badge bg-danger-light">
                            <i className="fe fe-x me-1"></i>Denied
                        </span>
                    )}
                    {status == "Deleted" && (
                        <span className="badge bg-warning">
                            <i className="fe fe-x me-1"></i>Deleted
                        </span>
                    )}
                    {status == "applied" && (
                        <span className="badge bg-secondary">
                            <i className="fe fe-check me-1"></i>applied
                        </span>
                    )}
                </div>
            ),
            sorter: (a, b) => a.status.localeCompare(b.status),
        },

        {
            title: "Action",
            dataIndex: "Action",
            render: (text, record) => (
                <div className="table-invoice d-flex align-items-center">
                    <div className="dropdown dropdown-action">
                        <a
                         
                            className="btn-action-icon"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.preventDefault()}
                        >
                            <i className="fas fa-ellipsis-v" />
                        </a>
                        <div className="dropdown-menu dropdown-menu-end">
                            <ul>
                                <li>
                                    <a
                                        className="dropdown-item"
                                       
                                        data-bs-toggle="modal"
                                        data-bs-target="#Message-view"
                                        onClick={() => { handleEditClick(record) }}
                                    >
                                        <i className="fe fe-edit me-2" /> view
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ),
        }

    ];


    return (
        <div>
            <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
                <Header onMenuClick={() => toggleMobileMenu()} />
                <Sidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        {/* Page Header */}
                        <div className="page-header">
                           <div className="content-page-header flex-column gap-3 ">
                                <h5>Messages</h5>
                                <div className="page-content">
                                    <div className="list-btn">
                                        <ul className="filter-list d-flex align-items-center justify-content-center flex-column flex-xl-row gap-2 gap-xl-0">
                                            <div className="d-flex flex-column flex-md-row gap-md-0">
                                            <li>
                                                {/* Search */}
                                                <form className="m-0 d-flex align-items-center">
                                                    <label className="form-label m-0">From</label>
                                                    <input
                                                        type="datetime-local"
                                                        className={`form-control ms-2 ${validation.fromDate ? "" : "input-error"
                                                            }`}
                                                        value={formData.fromDate}
                                                        onChange={(e) => setFormData({ ...formData, fromDate: e.target.value })}
                                                    />
                                                </form>
                                            </li>
                                            <li>
                                                {/* Search */}
                                                <form className="m-0 d-flex align-items-center">
                                                    <label className="form-label ms-2 mb-0">To</label>
                                                    <input
                                                        type="datetime-local"
                                                        className={`form-control ms-2  ${validation.ToDate ? "" : "input-error"
                                                            }`}
                                                        value={formData.ToDate}
                                                        onChange={(e) => setFormData({ ...formData, ToDate: e.target.value })}
                                                    />
                                                </form>
                                            </li>
                                            </div>
                                            <div className="d-flex gap-2 ">
                                            <li>
                                                <a
                                                    className="btn btn-primary"
                                                  
                                                    onClick={HandleGenerate}
                                                >
                                                     <i
                            className="fa fa-cogs me-2"
                            aria-hidden="true"
                          />
                                                    Generate
                                                </a>
                                            </li>


                                            {isExport && <li>
                                                <a
                                                    className="d-flex align-items-center download-item btn btn-filters"
                                                 
                                                    download=""
                                                    onClick={(e) => {
                                                        e.preventDefault(); HandleExport(datasource);
                                                    }}
                                                >
                                                    <i className="far fa-file-text me-2" />
                                                    Export
                                                </a>
                                            </li>}</div>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* /Page line */}
                        <div className="super-admin-list-head">
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-table">
                                    <div className="card-body">
                                        {isLoding ? <div className="d-flex justify-content-center">
                                            <div className="spinner-border" role="status" />
                                        </div>
                                            : <div className="table-responsive">
                                                <Table
                                                   pagination={{
                          total: datasource.length,
                          showSizeChanger: true,
                          // onShowSizeChange: onShowSizeChange,
                          // itemRender: itemRender,
                        }}
                                                    rowKey="id"  
                                                    columns={columns}
                                                    dataSource={datasource}
                                                />
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MessageView Emp_data={EditData} fetchmessage={fetchmessage} />
        </div>
    );
};

export default Message;
